

























































































































































































































  import { namespace } from "vuex-class";
  import { Component, Prop, Vue } from "vue-property-decorator";
  import { List } from "linq-collections";
  import rest from "@/rest";
  import { vuex } from "@/store";
  import _ from "lodash";
  import draggable from "vuedraggable";
  import { signalrEventBus } from "@/main";
  // import wretch, { WretcherError } from "wretch";
  // Components
  import EditBundleDlg from "./EditBundleDlg.vue";
  import SimpleMessageBox from "../Shared/SimpleMessageBox.vue";

  // Interfaces
  import { ParamDictionary } from "@/interfaces/ParamDictionary";
  import { ExBundleGroupVM, ExBundleVM } from '@/interfaces/ExBundleGroupVM';
  import { ExCategory1 } from "@/interfaces/ExCategory1";
  import { ExCategory2 } from "@/interfaces/ExCategory2";
  import { CategorySelectListsVm, ExCategory3 } from "@/interfaces/CategorySelectListsVm";

  const auth = namespace("auth");
  const ux = namespace("ux");
  const globals = namespace("globals");

  @Component({
    components: {
      draggable,
      EditBundleDlg,
      SimpleMessageBox
    }
  })
  export default class BundleSelection extends Vue {
    // @Prop() showActions!: boolean;
    @Prop() isContentCreator!: boolean;
    @Prop() onlyOldBundles!: boolean;
    @Prop() busyWithZipCreation!: boolean;
    @Prop() sendSelectionEventOnBundlesUpdate!: boolean;
    @Prop() addSpecialFolders!: boolean;

    @auth.Getter isAdmin: any;
    @globals.Getter selectedBundle: any;
    @globals.Getter selectedCategory1!: ExCategory1 | null;
    @globals.Getter selectedCategory2!: ExCategory2 | null;
    @globals.Getter selectedCategory3!: ExCategory3 | null;

    busyWithZipArchiveCreation = false;
    category1Items: ExCategory1[] = [];
    category2Items: ExCategory2[] = [];
    category3Items: ExCategory3[] = [];

    // selectedCat1Item: ExCategory1 | null = null;
    // selectedCat2Item: ExCategory2 | null = null;

    exBundleGroups: ExBundleGroupVM[] = [];
    selectedBundleGroupPanel: number | null = null;
    selectedBundleForEdit: ExBundleVM | null = null;
    showEditBundleDlg = false;
    selectedBundleToDelete: ExBundleVM | null = null;
    showConfirmDeleteBundleDlg = false;
    selectedBundleToClone: ExBundleVM | null = null;
    showConfirmCloneBundleDlg = false;
    guid: string = "";

    // $refs!: { };

    async mounted() {
      await this.updateView();
    }

    created() {
      // SignalR event listener
      signalrEventBus.$on('zipArchiveCreationFinished', this.zipArchiveCreationFinished);
      signalrEventBus.$on('backgroundTaskEvent', this.backgroundTaskEvent);
    }

    beforeDestroy() {
      // clearAllBodyScrollLocks();
      // Make sure to cleanup SignalR event handlers when removing the component
      signalrEventBus.$off('zipArchiveCreationFinished', this.zipArchiveCreationFinished);
      signalrEventBus.$off('backgroundTaskEvent', this.backgroundTaskEvent);
    }


    // SignalR events
    zipArchiveCreationFinished(response: any) {
      // Download will be started by parent view
      // if (response.status == "SUC") {
      //   this.$globalHelper.download(`api/resource/Temp/${response.zipFileName}`, response.zipFileName);
      // } else {
      // }

      // this.$emit('content:ZipArchiveCreationFinished');
      this.busyWithZipArchiveCreation = false;
    }

    async backgroundTaskEvent(response: { id: string, progress: number, message: string, status: string }) {
      if (this.guid !== response.id) return;
      console.log("BundleSelection > Background task event:", response);
      if (response.status == "INF") {
        vuex.ux.SB_SUCCESS({
          message: response.message,
          timeout: 1500
        });
        return;
      }
    }

    public async updateView() {
      if (this.selectedBundle)
        await this.loadCategories("selectGuid", this.selectedBundle.guid);
      else
        await this.loadCategories("cat1", "");

      await this.getGroupedExBundles();
    }

    // Search Bundles
    searchBundle: string = "";
    bundleSuggestions: ExBundleVM[] = [];
    selectedBundleSuggestion: ExBundleVM | null = null;
    isLoadingBundleSuggestions: boolean = false;

    debouncedSearchBundle = _.debounce(this.loadBundleSuggestions, 700, { leading: true, trailing: true});

    async onBundleSuggestionCleared() {
      // console.log("onBundleSuggestionCleared");
      this.searchBundle = "";
      this.selectedBundleSuggestion = null;
      await this.loadBundleSuggestions();
    }

    async loadBundleSuggestions() {
      // console.log("loadBundleSuggestions", this.searchBundle);
      this.isLoadingBundleSuggestions = true
      this.bundleSuggestions = [];

      let params: ParamDictionary = { dictionary: {}};
      params.dictionary!["Search"] = this.searchBundle;
      params.dictionary!["OnlyUnreleased"] = "false";
      params.dictionary!["ShowOnlyContentCreatorBundles"] = this.isContentCreator ? "true" : "false";
      params.dictionary!["ShowOnlyOldBundles"] = this.onlyOldBundles ? "true" : "false";

      await rest.url("contentManager/loadBundleSuggestions")
        .post(params)
        .then((response) => {
          this.bundleSuggestions = response;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.isLoadingBundleSuggestions = false;
        });
    }

    async onBundleSuggestionSelected() {
      // console.log("onBundleSuggestionSelected");
      if (!this.selectedBundleSuggestion) return;

      let exCat1 = <ExCategory1>{ id: this.selectedBundleSuggestion?.categoryId1, name: this.selectedBundleSuggestion?.category1 };
      vuex.globals.setCategory1(exCat1);

      let exCat2 = <ExCategory2>{ id: this.selectedBundleSuggestion?.categoryId2, name: this.selectedBundleSuggestion?.category2 };
      vuex.globals.setCategory2(exCat2);

      await this.loadCategories("cat1", "");

      vuex.globals.setBundle(this.selectedBundleSuggestion);
      await this.getGroupedExBundles();
    }

    async cat1Changed(cat1: ExCategory1) {
      // this.selectedCat1Item = cat1;
      vuex.globals.setCategory1(cat1);
      await this.onBundleSuggestionCleared();
      await this.loadCategories("cat1", "");
      await this.getGroupedExBundles();
    }

    async cat2Changed(cat2: ExCategory2) {
      // this.selectedCat2Item = cat2;
      vuex.globals.setCategory2(cat2);
      await this.onBundleSuggestionCleared();
      await this.loadCategories("cat2", "");
      await this.getGroupedExBundles();
    }

    async loadCategories(changeEvent: string, selectGuid: string): Promise<void> {
      let paramDir: ParamDictionary = { dictionary: {}};
      if (paramDir == null || paramDir.dictionary == null)
        return;

      paramDir.dictionary["ChangeEvent"] = changeEvent;
      paramDir.dictionary["SelectGuid"] = selectGuid ?? "";
      // paramDir.dictionary["Category1Id"] = this.selectedCat1Item?.id.toString() ?? "0";
      // paramDir.dictionary["Category2Id"] = this.selectedCat2Item?.id.toString() ?? "0";
      // paramDir.dictionary["Category3Id"] = "0";
      paramDir.dictionary!["Category1Id"] = this.selectedCategory1?.id.toString() ?? "0";
      paramDir.dictionary!["Category2Id"] = this.selectedCategory2?.id.toString() ?? "0";
      paramDir.dictionary!["Category3Id"] = this.selectedCategory3?.id.toString() ?? "0";

      await rest.url("exercises/loadAllCategories")
      .post(paramDir)
      .then((result: CategorySelectListsVm) => {
        this.category1Items = result.category1Items!;
        vuex.globals.setCategory1(result.selectedCat1Item);

        this.category2Items = result.category2Items!;
        vuex.globals.setCategory2(result.selectedCat2Item);

        this.category3Items = result.category3Items!;
        vuex.globals.setCategory3(result.selectedCat3Item);
      })
    }

    get selectedCat1ItemName() {
      if (!this.selectedCategory1)
        return "-";
      return this.selectedCategory1.name;
    }

    get selectedCat2ItemName() {
      if (!this.selectedCategory2)
        return "-";
      return this.selectedCategory2.name;
    }

    async getGroupedExBundles() {
      this.exBundleGroups = [];
      let param: ParamDictionary = { dictionary: {}};
      param.dictionary!["Category1Id"] = (this.selectedCategory1?.id ?? 0).toString();
      param.dictionary!["Category2Id"] =  (this.selectedCategory2?.id ?? 0).toString();
      param.dictionary!["AddSpecialFolders"] = this.addSpecialFolders ? "true" : "false";
      param.dictionary!["ShowOnlyContentCreatorBundles"] = this.isContentCreator ? "true" : "false";
      param.dictionary!["ShowOnlyOldBundles"] = this.onlyOldBundles ? "true" : "false";

      this.exBundleGroups = await rest.url("contentManager/getGroupedExBundles").post(param);

      if (this.selectedBundle == null)
        return;

      // let catName = this.selectedBundle.category3;
      // if (catName == null) {
      //   vuex.globals.setBundle(null);
      //   return;
      // }

      let group = new List(this.exBundleGroups).singleOrDefault(g => new List(g.bundles!).any(b => b.guid == this.selectedBundle.guid));
      vuex.globals.setBundle(group?.bundles?.find(b => b.guid == this.selectedBundle.guid) ?? null);
      if (group) {
        // open expansion panel
        let index = this.exBundleGroups.indexOf(group);
        this.selectedBundleGroupPanel = index;

        // select bundle
        if (this.sendSelectionEventOnBundlesUpdate)
          this.onBundleSelected(this.selectedBundle);
      }
    }

    onBundleSelected(bundle: ExBundleVM) {
      vuex.globals.setBundle(bundle);
      this.$emit('bundleSelected:BundleSelection', bundle);
    }

    async onCreateCategory2Archive() {
      this.busyWithZipArchiveCreation = true;
      this.$emit('createCategory2Archive:BundleSelection', { cat1Name: this.selectedCat1ItemName, cat2Name: this.selectedCat2ItemName });

      await this.$l3rnOnlineHub.ensureConnection();

      let params: ParamDictionary = { dictionary: {}};
      params.dictionary!["SignalRId"] = this.$l3rnOnlineHub.ConnectionId!;
      params.dictionary!["Category1"] = this.selectedCat1ItemName!;
      params.dictionary!["Category2"] = this.selectedCat2ItemName!;

      await rest.url("contentManager/createCategory2Archive")
        .post(params)
        .then((guid) => {
          this.guid = guid;
        });
    }

    onEditBundle(bundle: ExBundleVM) {
      this.selectedBundleForEdit = bundle;
      this.showEditBundleDlg = true;
      // this.$emit('edit:BundleSelection', bundle);
    }

    onCloneBundle(bundle: ExBundleVM) {
      this.selectedBundleToClone = bundle;
      this.showConfirmCloneBundleDlg = true;
    }

    async cloneBundle() {
      let fileDownloadParam: ParamDictionary = { dictionary: {}};
      fileDownloadParam.dictionary!["BundleId"] =  this.selectedBundleToClone!.id.toString();
      // fileDownloadParam.dictionary!["LocalPath"] = this.selectedBundleToDelete!.localPath ?? "";

      await rest.url("contentManager/cloneBundle").post(fileDownloadParam);
      this.showConfirmCloneBundleDlg = false;
      await this.updateView();
      this.$emit('updated:BundleSelection');
    }

    async onBundleChanged() {
      await this.updateView();
      this.$emit('updated:BundleSelection');
    }

    onDeleteBundle(bundle: ExBundleVM) {
      // this.$emit('delete:BundleSelection', bundle);
      this.selectedBundleToDelete = bundle;
      this.showConfirmDeleteBundleDlg = true;
    }

    async deleteBundle() {
      let fileDownloadParam: ParamDictionary = { dictionary: {}};
      fileDownloadParam.dictionary!["BundleId"] =  this.selectedBundleToDelete!.id.toString();
      fileDownloadParam.dictionary!["LocalPath"] = this.selectedBundleToDelete!.localPath ?? "";

      await rest.url("contentManager/removeBundleWithFiles").post(fileDownloadParam);
      this.showConfirmDeleteBundleDlg = false;
      await this.updateView();
      this.$emit('updated:BundleSelection');
    }

    async onDragEnd(bundleGroup: ExBundleGroupVM): Promise<void> {
      // console.log("onDragEnd", bundleGroup);
      await rest.url("contentManager/updateExBundleOrder")
      .post(bundleGroup)
      .then((result: CategorySelectListsVm) => {
      })
    }

    getPageBorderStyle(bundle: ExBundleVM) {
      if (bundle == this.selectedBundle)
        return `border: 2px solid ${this.$store.state.ux.colorAccent};`;
      return "";
    }

    // replace with vuex variant
    get backgroundColor() {
      let currentThemeName = this.$vuetify.theme.dark ? 'dark' : 'light';
      return this.$vuetify.theme.themes[currentThemeName].background;
    }
  }
